<template>
	<div class="basic_wrap">
	  <div class="user-top">
		<div class="user-name">
		  <p style="font-size: 18px; margin-bottom: 6px;">
			Hello !
		  </p>
		  <p>用科技表达我们的爱</p>
		</div>
	  </div>
	  <div class="login-main">
		<form class="form">
		  <div class="item mt" :class="{ 'has-error': usernameError }">
			<span class="icon">
			  <img
				src="../images/login/uname.png"
				alt=""
			  >
			</span>
			<input
			  v-model.trim="data.username"
			  type="text"
			  class="inp"
			  placeholder="请输入登录账号（英文和数字）"
			  @input="validateUsername"
			>
			<!-- 添加账号验证提示 -->
			<div v-if="usernameError" class="error-tip">
			  {{ usernameError }}
			</div>
		  </div>
		  <div class="item">
			<span class="icon">
			  <img
				src="../images/login/pwd.png"
				alt=""
			  >
			</span>
			<input
			  v-model.trim="data.password"
			  :type="password"
			  class="inp"
			  placeholder="请输入登录密码"
			>
		  </div>
		  <div class="item">
			<span class="icon">
			  <img
				src="../images/login/pwd2.png"
				alt=""
			  >
			</span>
			<input
			  v-model.trim="data.spassword"
			  :type="password"
			  class="inp"
			  placeholder="请确认登录密码"
			>
		  </div>

		  <div class="item" :class="{ 'has-error': paypwdError }">
			<span class="icon">
			  <img
				src="../images/login/pay_pwd.png"
				alt=""
			  >
			</span>
			<input
			  v-model.trim="data.paypwd"
			  type="password"
			  class="inp"
			  maxlength="6"
			  placeholder="请输入6位数字支付密码"
			  @input="validatePayPassword"
			>
			<!-- 添加验证提示 -->
			<div v-if="paypwdError" class="error-tip">
			  {{ paypwdError }}
			</div>
		  </div>

		  <div
			v-if="show_sms > 0"
			class="item"
		  >
			<input
			  v-model.trim="data.code"
			  type="text"
			  class="inp"
			  :placeholder="$t('register.code')"
			>
			<van-count-down
			  :time="time"
			  class="btn get_captcha"
			  @finish="timeCall"
			>
			  <template v-slot="timeData">
				<span @click="sendcode">{{
				  timeData.seconds > 0
					? timeData.seconds
					: $t('register.sendCode')
				}}</span>
			  </template>
			</van-count-down>
		  </div>
		  <div class="item">
			<span class="icon">
			  <img
				src="../images/login/invite.png"
				class="people"
				alt=""
			  >
			</span>
			<input
			  v-model.trim="data.code"
			  type="text"
			  class="inp"
			  :placeholder="$t('register.referralCode')"
			>
		  </div>
		  <div
			class="basic_btn sbtn"
			:class="data.username == '' ||
			  data.password == '' ||
			  data.spassword == '' ||
			  data.paypwd == '' ||
			  paypwdError ||
			  usernameError
			  ? 'no_touch'
			  : ''
			"
			@click="submit"
		  >
			{{ $t('register.signUpBtn') }}
		  </div>
		  <a
			href="/#/login"
			class="return-login"
		  >
			已有账号？返回登录
		  </a>
		</form>
	  </div>

	  <van-dialog
		v-model="statement"
		confirm-button-color="#fb661e"
		:close-on-click-overlay="true"
		@click="privacyStatementHide"
	  />
	  <van-dialog
		v-model="agreement"
		confirm-button-color="#fb661e"
		:close-on-click-overlay="true"
		@click="agreementHider"
	  />
	</div>
  </template>

  <script>
  import Vue from "vue";
  import {
	  CountDown,
	  Checkbox,
	  Dialog
  } from "vant";
  import Fetch from "../../utils/fetch";

  Vue.use(CountDown)
	  .use(Checkbox)
	  .use(Dialog);

  export default {
	  name: "Register",
	  data () {
		  return {
			  time: 0,
			  agreement: false,
			  statement: false,
			  show_kefu: false,
			  msg_show: true,
			  show_sms: 0,
			  password: "password",
			  usernameError: "", // 用户名错误提示
			  paypwdError: "", // 支付密码错误提示
			  data: {
				  password: "",
				  spassword: "",
				  username: "", // 修改为username字段
				  t_mobile: "",
				  code: "",
				  paypwd: "", // 支付密码
				  agent: 10000
			  },
			  showPopover: false,
			  actions: [
				  { text: '中国', icon: require('../images/language/zh_cn.png'), },
				  { text: 'English', icon: require('../images/language/en_us.png'), },
				  { text: '日本', icon: require('../images/language/ja_jp.png'), },
				  { text: 'Brasil', icon: require('../images/language/ko_kr.png'), },
				  { text: 'Việt Nam', icon: require('../images/language/vi_vn.png'), },
				  { text: 'Malaysia', icon: require('../images/language/th_th.png'), },
				  { text: 'ประเทศไทย', icon: require('../images/language/ms_my.png'), },
				  { text: 'Indonesia', icon: require('../images/language/zh_hk.png'), },
			  ],
			  lan_num: '中国',
			  lan_ico: require('../images/language/zh_cn.png'),
			  config: {}
		  };
	  },
	  created () {
		  this.$parent.footer("user", false);
		  this.getparams();
	  },
	  mounted () {
		  document.getElementById('app').style.backgroundColor = '#fff';
		  if (this.$route.query.agent) {
			  localStorage.setItem('agent', this.$route.query.agent);
			  this.data.agent = this.$route.query.agent;
		  } else {
			  if (localStorage.getItem('agent')) {
				  this.data.agent = localStorage.getItem('agent');
			  }
		  }
		  var that = this;
		  document.body.addEventListener(
			  "scroll",
			  function () {
				  if (!that.show_kefu) {
					  return;
				  }
				  that.show_kefu = false;
			  },
			  false
		  );
		  document.addEventListener(
			  "click",
			  function (ev) {
				  if (ev.target.className != "kefu_img") {
					  that.show_kefu = false;
				  }
			  },
			  false
		  );
		  Fetch('/index/webconfig', {
			  type: 'web'
		  }).then(res => {
			  this.config = res.data
			  this.show_sms = res.data.sms_verify
		  })
	  },
	  methods: {
		  onSelect (action) {
			  console.log(action)
			  this.lan_ico = action.icon
			  this.lan_num = action.text
			  let lang
			  if (action.text == "中国") {
				  lang = "zh_cn"
			  }
			  if (action.text == "English") {
				  lang = "en_us"
			  }
			  if (action.text == "日本") {
				  lang = "ja_jp"
			  }
			  if (action.text == "Brasil") {
				  lang = "ko_kr"
			  }
			  if (action.text == "Việt Nam") {
				  lang = "vi_vn"
			  }
			  if (action.text == "Malaysia") {
				  lang = "th_th"
			  }
			  if (action.text == "ประเทศไทย") {
				  lang = "ms_my"
			  }
			  if (action.text == "Indonesia") {
				  lang = "zh_hk"
			  }
			  this.$i18n.locale = lang;
			  localStorage.setItem("lang", lang);
		  },
		  kefu_to () {
			  if (this.show_kefu) {
				  this.$router.push("/kefu");
			  }
			  this.show_kefu = !this.show_kefu;
		  },
		  showPwd () {
			  if (this.password == "password") {
				  this.password = "text";
			  } else {
				  this.password = "password";
			  }
		  },
		  methodName (r) {
			  this.data.imei = r;
		  },
		  getExternalInfoData (info) {
			  var info = JSON.parse(info);
			  console.log(info);
			  if (info.code == 0) {
				  this.data.oaid = info.oaid;
			  }
		  },
		  getparams () {
			  var m = this.$route.query.m;
			  this.data.t_mobile = m;
		  },
		  timeCall () {
			  this.is_send = false;
			  this.time = 0;
		  },
		  
		  // 验证用户名格式（只能英文和数字）
		  validateUsername() {
			const username = this.data.username;
			
			if (!username) {
				this.usernameError = "";
				return;
			}
			
			// 验证规则：只能包含英文和数字，长度3-20位
			const regex = /^[a-zA-Z0-9]{3,20}$/;
			
			if (!regex.test(username)) {
				this.usernameError = "登录账号只能使用3-20位英文和数字";
				return;
			}
			
			// 可选：验证不能是纯数字（如果需要的话）
			// if (/^\d+$/.test(username)) {
			//   this.usernameError = "登录账号不能是纯数字";
			//   return;
			// }
			
			// 可选：验证不能是纯字母（如果需要的话）
			// if (/^[a-zA-Z]+$/.test(username)) {
			//   this.usernameError = "登录账号不能是纯字母";
			//   return;
			// }
			
			this.usernameError = "";
		  },
		  
		  sendcode () {
			  if (this.is_send) {
				  return;
			  }

			  // 验证用户名格式
			  if (!this.data.username) {
				  this.$toast("请输入登录账号");
				  return;
			  }
			  
			  // 验证用户名格式（只能英文和数字）
			  const usernameRegex = /^[a-zA-Z0-9]{3,20}$/;
			  if (!usernameRegex.test(this.data.username)) {
				  this.$toast("登录账号只能使用3-20位英文和数字");
				  return;
			  }

			  this.is_send = true;

			  // 注意：这里可能需要根据后端接口调整参数名
			  Fetch("/index/register_code", {
				  username: this.data.username, // 修改为username
			  })
				  .then(() => {
					  this.time = 60 * 1000;
					  this.$toast({
						  background: "#07c160",
						  message: this.$t('register.sendSuccess'),
					  });
				  })
				  .catch(() => {
					  this.is_send = false;
				  });
		  },

		  // 验证支付密码格式
		  validatePayPassword() {
			const paypwd = this.data.paypwd;
			
			if (!paypwd) {
				this.paypwdError = "";
				return;
			}
			
			// 验证是否为6位数字
			const regex = /^\d{6}$/;
			
			if (!regex.test(paypwd)) {
				this.paypwdError = "支付密码必须是6位数字";
				return;
			}
			
			// 验证是否为连续数字（增强安全性）
			// if (this.isSequentialNumber(paypwd)) {
			// 	this.paypwdError = "支付密码不能是连续数字";
			// 	return;
			// }
			
			// 验证是否为重复数字（增强安全性）
			// if (this.isRepeatedNumber(paypwd)) {
			// 	this.paypwdError = "支付密码不能是重复数字";
			// 	return;
			// }
			
			this.paypwdError = "";
		  },
		  
		  // 检查是否为连续数字
		  isSequentialNumber(str) {
			const sequences = [
				'012345', '123456', '234567', '345678', '456789', '567890',
				'098765', '987654', '876543', '765432', '654321', '543210'
			];
			return sequences.includes(str);
		  },
		  
		  // 检查是否为重复数字
		  isRepeatedNumber(str) {
			return /^(\d)\1{5}$/.test(str);
		  },
		  
		  submit () {
			// 先验证用户名
			if (!this.data.username) {
				this.$toast({
					className: "toastName",
					message: "请输入登录账号",
				});
				return false;
			}
			
			// 验证用户名格式
			const usernameRegex = /^[a-zA-Z0-9]{3,20}$/;
			if (!usernameRegex.test(this.data.username)) {
				this.$toast({
					className: "toastName",
					message: "登录账号只能使用3-20位英文和数字",
				});
				return false;
			}
			
			// 验证密码
			if (!this.data.password) {
				this.$toast({
					className: "toastName",
					message: this.$t('register.passwordEmpty'),
				});
				return false;
			}
			
			// 验证确认密码
			if (!this.data.spassword) {
				this.$toast(this.$t('register.passwordAgainEmpty'));
				return false;
			}
			
			// 验证支付密码
			if (!this.data.paypwd) {
				this.$toast({
					className: "toastName",
					message: "请输入支付密码",
				});
				return false;
			}
			
			// 支付密码格式验证
			if (this.data.paypwd.length !== 6) {
				this.$toast({
					className: "toastName",
					message: "支付密码必须是6位数字",
				});
				return false;
			}
			
			if (!/^\d{6}$/.test(this.data.paypwd)) {
				this.$toast({
					className: "toastName",
					message: "支付密码必须是6位数字",
				});
				return false;
			}

			// 验证短信验证码
			if (!this.data.code && this.config.sms_verify) {
				this.$toast({
					className: "toastName",
					message: this.$t('register.codeEmpty'),
				});
				return false;
			}
			
			// 验证两次密码是否一致
			if (this.data.password != this.data.spassword) {
				this.$toast(this.$t('register.passwordError'));
				return false;
			}

			// 提交注册
			Fetch("/index/register", {
				...this.data,
				// 如果后端需要mobile字段，可以这样处理：
				// mobile: this.data.username, // 如果后端接口要求mobile字段
			}).then((res) => {
				if (res.data.token) {
					localStorage.setItem('token', res.data.token);
				}
				this.$toast({
					className: "toastName",
					message: this.$t('register.signUpSuccess'),
				});
				this.$router.replace("/");
			});
		  },
		  
		  userAgreement () {
			  this.agreement = true;
		  },
		  
		  agreementHider () {
			  this.agreement = false;
		  },
		  
		  privacyStatement () {
			  this.statement = true;
		  },
		  
		  privacyStatementHide () {
			  this.statement = false;
		  },
	  },
  };
  </script>

  <style lang="less" scoped>
  #app{
	  background-color: #fff;
  }
  .user-top {
	  padding: 85px 1rem 50px .8rem;
		  color: #0e2b8e;
		  text-align: left;
  
	  img {
		  width: 60px;
		  height: 60px;
		  border-radius: 60px;
		  border: 2px solid #ffffff;
	  }
  
	  .user-name {
		  font-size: 16px;
		  margin-top: 10px;
	  }
	  .user-name p{
		  font-size: 12px;
	  }
  }
  
  .basic_wrap {
	  position: relative;
	  background: url(../images/login/register.jpg) no-repeat center top;
	  background-size: 120%;
	  background-color: #fff;
	  .lan-box {
		  position: absolute;
		  top: 10px;
		  left: 25px;
	  }
  }
  
  .login_bg {
	  width: 100%;
	  overflow: hidden;
  
	  .language {
		  position: absolute;
		  top: 4px;
		  right: 0;
		  height: 36px;
  
		  img {
			  height: 100%;
		  }
	  }
  }
  
  .login-main {
	  
  }
  
  .basic_wrap .login-main {
	  padding: 0.2rem 1.2rem;
		  position: relative;
		  width: 100%;
		  border-radius: .8rem;
		  background-color: #fff;
		  margin-top:1.15rem
  }
  
  .cut_login {
	  width: 207px;
	  line-height: 25px;
	display: flex;
	  align-items: center;
	  justify-content: center;
	  font-size: 18px;
	  text-align: center;
	  margin: 0 auto;
  
	  a {
		  width: 50%;
		  padding-bottom: 10px;
		  color: #ceced0;
		  position: relative;
  
		  .line {
			  width: 100%;
			  height: 1px;
			  position: absolute;
			  left: 0;
			  bottom: 0;
			  background-color: #f2f2f2;
		  }
	  }
  
	  a.cur {
		  color: #f12211;
  
		  .line {
			  height: 2px;
			  background-image: linear-gradient(to right, #f12211, #f18a11);
		  }
	  }
  }
  
  .mt {
	  margin-top: 20px;
  }
  
  .item {
	  height: 40px;
	  border-bottom: dashed .03rem #D6D6D6;
	  font-size: 14px;
	  display: flex;
	  justify-content: flex-start;
	  align-items: center;
	  margin-bottom: 15px;
	  position: relative;
  
	  .icon {
		  width: 20px;
		  min-width: 20px;
		  text-align: center;
		  height: 20px;
  
		  img {
			  width: 17px;
		  }
	  }
  
	  input {
		  margin-left: 10px;
			  flex: 1;
			  color: #333;
			  font-size: .4rem;
	  }
	  input::placeholder {
		  color:#7c7c7c
	  }
	  
	  // 错误状态样式
	  &.has-error {
		  input {
			  color: #ff4444;
		  }
	  }
  }
  
  // 错误提示样式
  .error-tip {
	  position: absolute;
	  bottom: -18px;
	  left: 30px;
	  color: #ff4444;
	  font-size: 12px;
	  white-space: nowrap;
  }
  
  .item_reset_pwd {
	  font-size: 14px;
	  color: #3d96ff;
	  text-align: right;
	  margin-top: 10px;
	  line-height: 20px;
  }
  
  .van-checkbox {
	  margin-top: 20px;
  }
  
  /deep/ .van-checkbox__icon--checked .van-icon {
	  color: #fff;
	  background-color: #ff5a50;
	  border-color: #ff5a50;
  }
  
  /deep/ .van-checkbox__label {
	  color: #ff5a50;
  }
  
  .reset_pwd {
	  color: #333;
	  margin-top: -20px;
	  display: block;
  }
  
  .basic_btn {
	  margin: 50px auto 0 auto;
	  background: linear-gradient(to left, #756ff3, #399ffe);
	  color:#fff !important
  }
  
  // 禁用按钮样式
  .no_touch {
	  opacity: 0.6;
	  pointer-events: none;
  }
  
  .lan-label {
	  display: flex;
	  align-items: center;
	  white-space: nowrap;
	  height: 48px;
	  min-width: 24px;
	  height: 25px;
	  padding-right: 8px;
	  border-radius: 25px;
	  background-image: linear-gradient(to right, #ffff80, #ffffff);
  }
  
  .lan-label span {
	  display: inline-block;
	  margin-left: 3px;
  }
  
  .lan-label img {
	  width: 22px;
	  height: 22px;
  }
  
  .kefu-link {
	  padding: 20px;
	  text-align: center;
  }
  
  .kefu-link img {
	  width: 35px;
  }
  
  .show-body {
	  padding: 30px 30px 15px 30px;
	  text-align: center;
  }
  </style>
  
  <style>
  .van-popover {
	  width: 120px;
  }
  
  .van-popover__action {
	  height: 40px;
	  line-height: 40px;
  }
  
  .van-popover .van-popover__action-text::after {
	  left: -100px;
  }
  
  .van-popover__action-icon {
	  border: 1px solid #ececec;
	  border-radius: 30px;
  }
  
  .van-popover__action {
	  padding: 0 10px;
  }
  .return-login{
	  text-align: center;
		  color: #0e2b8d;
		  font-size: .36rem;
		  margin-top: .5rem;
		  display: block;
  }
  </style>